export const FEATURE_MY_DOCUMENT_RETENTION = true;
export const FEATURE_BROWSE_REPOSITORIES = false;
export const FEATURE_FILE_HISTORY = false;
export const FEATURE_MANIFEST_GATE = true;
export const FEATURE_UPLOAD_V2 = true;
export const FEATURE_UPLOAD_STORAGE_PREFLIGHT = false;
export const MAX_FOLDER_DOWNLOAD_FILES = 250000;
export const MAX_FOLDER_DOWNLOAD_BYTES = 1099511627776;
export const MAX_FOLDER_DELETE_FILES = 250000;
export const EXPIRED_ITEMS_HIGH_COUNT_THRESHOLD = 10000;
